interface PlaceholderParams {
  isRootOperator: boolean
  isSysAdmin: boolean
  hasMultipleSystems: boolean
  selectedSystem: string | null
  isAll: boolean
  isLoading: boolean
  entityName: string
}

export function getMultiSelectPlaceholder({
  isRootOperator,
  isSysAdmin,
  hasMultipleSystems,
  selectedSystem,
  isAll,
  isLoading,
  entityName,
}: PlaceholderParams): string {
  if (isRootOperator) return `Root Operator has access to all ${entityName}`
  if (isSysAdmin) return `System Administrator has access to all ${entityName}`
  if (hasMultipleSystems) return `Multiple systems: All ${entityName} granted`
  if (!selectedSystem) return 'Select a single system first'
  if (isAll) return `Access granted to all ${entityName}`
  if (isLoading) return `Loading ${entityName}...`
  return `Select ${entityName}...`
}

interface LocationPlaceholderParams {
  isRootOperator: boolean
  isSysAdmin: boolean
  hasMultipleSystems: boolean
  selectedSystem: string | null
  locationsAll: boolean
}

export function getLocationPlaceholder({
  isRootOperator,
  isSysAdmin,
  hasMultipleSystems,
  selectedSystem,
  locationsAll,
}: LocationPlaceholderParams): string {
  if (isRootOperator) return 'Root Operator has access to all locations'
  if (isSysAdmin) return 'System Administrator has access to all locations'
  if (hasMultipleSystems) return 'Multiple systems: All locations granted'
  if (!selectedSystem) return 'Select a single system first'
  if (locationsAll) return 'Access granted to all locations'
  return 'Select locations...'
}

export function getSystemsPlaceholder(
  isRootOperator: boolean,
  systemsAll: boolean | undefined
): string {
  if (isRootOperator) return 'Root Operator has access to all systems'
  if (systemsAll) return 'Access granted to all systems'
  return 'Select systems...'
}
